import { AlertDialog, Button } from '@heroui/react'
import type { ReactNode } from 'react'

export interface ConfirmDeleteDialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  heading: string
  confirmLabel: string
  isPending?: boolean
  onConfirm: () => void
  children: ReactNode
}

export const ConfirmDeleteDialog = ({
  isOpen,
  onOpenChange,
  heading,
  confirmLabel,
  isPending = false,
  onConfirm,
  children,
}: ConfirmDeleteDialogProps) => (
  <AlertDialog.Backdrop
    variant="blur"
    isOpen={isOpen}
    onOpenChange={onOpenChange}
  >
    <AlertDialog.Container placement="center">
      <AlertDialog.Dialog className="sm:max-w-[420px]">
        <AlertDialog.CloseTrigger />
        <AlertDialog.Header>
          <AlertDialog.Icon status="danger" />
          <AlertDialog.Heading>{heading}</AlertDialog.Heading>
        </AlertDialog.Header>
        <AlertDialog.Body>{children}</AlertDialog.Body>
        <AlertDialog.Footer>
          <Button slot="close" variant="tertiary">
            Cancel
          </Button>
          <Button variant="danger" onPress={onConfirm} isPending={isPending}>
            {confirmLabel}
          </Button>
        </AlertDialog.Footer>
      </AlertDialog.Dialog>
    </AlertDialog.Container>
  </AlertDialog.Backdrop>
)
